//export const URL = "http://walksintra.api.betacode.tech/v1"; //test backend environment
export const URL = process.env.REACT_APP_API_URL; //localhost
//export const URL = "https://api.walksintra.app/v1"; //PRODUCTION API
